interface RecordingTimerProps {
  formattedTime: string;
  visible: boolean;
  isUrgent?: boolean;
}

/**
 * Timer display component for RecorderPanel.
 * Shows elapsed time / max time during recording.
 * Applies urgency styling when approaching time limit.
 */
export function RecordingTimer({ formattedTime, visible, isUrgent = false }: RecordingTimerProps) {
  if (!visible) {
    return null;
  }

  return (
    <p
      className={`mt-3 text-[28px] font-[650] tabular-nums transition-colors duration-500 ${
        isUrgent ? "text-amber-400" : ""
      }`}
    >
      {formattedTime}
    </p>
  );
}
